// extracted by mini-css-extract-plugin
export default {"header":"header-module___header___cc74c0f7","coverageDanger":"header-module___coverageDanger___d020009e","coverageSuccess":"header-module___coverageSuccess___b3882d1c"};